export const API_ENDPOINTS = {
  SMS_LOGS: {
    Summary: '/text-message/logs',
    Detail: '/text-message/logs/details',
    Delete: '/text-message/logs/details/{id}',
    Bulk: '/text-message/logs/details/bulk',
    Send: '/text-message/logs/send',
  },
};
